import { render, staticRenderFns } from "./addScene.vue?vue&type=template&id=0beafa86&scoped=true&"
import script from "./addScene.vue?vue&type=script&lang=js&"
export * from "./addScene.vue?vue&type=script&lang=js&"
import style0 from "./addScene.vue?vue&type=style&index=0&id=0beafa86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beafa86",
  null
  
)

export default component.exports